import { getSeekerLeads } from '../../../../../apiclient/resources/seeker';
import * as actions from './actions';

const fetchLeads = (limit, offset, sorted) => dispatch => {
  dispatch(actions.fetchLeadsSeeker());
  getSeekerLeads(limit, offset, sorted).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsSeekerSucceeded(data));
    } else {
      dispatch(actions.fetchLeadsSeekerFailed(error));
    }
  });
};

const fetchLeadsMobileEvent = () => dispatch => {
  dispatch(actions.fetchLeadsMobileSucceededEvent({}));
};

const fetchLeadsMobile = (limit, offset, sorted) => dispatch => {
  dispatch(actions.fetchLeadsSeekerMobile);
  getSeekerLeads(limit, offset, sorted).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsSeekerSucceededMobile(data));
    } else {
      dispatch(actions.fetchLeadsSeekerFailedMobile(error));
    }
  });
};

const fetchLeadsMobileSorted = (limit, offset, sorted) => dispatch => {
  dispatch(actions.fetchLeadsSeekerMobile);
  getSeekerLeads(limit, offset, sorted).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsSeekerSucceededMobileSorted(data));
    } else {
      dispatch(actions.fetchLeadsSeekerFailedMobile(error));
    }
  });
};

const setParams = sorted => dispatch => {
  dispatch(actions.setLeadsOrderSeekers(sorted));
};

const SetOffSet = data => dispatch => {
  dispatch(actions.setLeadsOfSetSeeker(data));
};

export const { fetchLeadsSeeker, fetchLeadsSeekerSucceeded, setLeadsOrderSeekers, setLeadsOfSetSeeker } = actions;

export { fetchLeads, fetchLeadsMobileSorted, fetchLeadsMobile, fetchLeadsMobileEvent, setParams, SetOffSet };
